import React, { Fragment, useState, useEffect } from 'react'
import axios from 'axios'
import classNames from 'classnames'

const AjaxButton = (props) => {

  // required params
  // url
  // data

  // optional params
  // method (http method)
  // onSuccess
  // onError
  // buttonSize
  // className
  // style
  // label
  // labelSending

  const [sending, setSending] = useState(false)
  const [finished, setFinished] = useState(false)
  const {shortCut} = props

  const startRequest = () => {
    setSending(true)
    if (props?.setSending) {
      props?.setSending(true)
    }

    if (props?.beforeStartRequest) {
      props.beforeStartRequest()
    }

    let ajaxObj = axios({
        method: props.method ? props.method : "GET",
        url: props.url,
        data: typeof props.data === "function" ? props.data() : props.data
      }).then(
        (props.onSuccess ? props.onSuccess : (data) => {
          setFinished(true)
        }),
        (props.onError ? props.onError : (error) => {
          console.error(error)
          alert(error)
        }
        )).then(function() {
          setSending(false)
          if (props?.setSending) {
            props?.setSending(false)
          }
        });
  }


  useEffect(() => {
    if (shortCut) {
      const listener = (e) => {
        if (sending) {
          return
        }

        let currentArray = []

        if (e.ctrlKey) {
          currentArray.push("CTRL")
        }

        if (e.altKey) {
          currentArray.push("ALT")
        }

        if (e.shiftKey) {
          currentArray.push("SHIFT")
        }

        currentArray.push(e.key)

        const currentKey = currentArray.join("+").toLowerCase()
        const curatedShortcut = shortCut.replaceAll(" ", "").toLowerCase()

        if (currentKey === curatedShortcut) {
          e.preventDefault()
          startRequest()
        }
      }
      document.addEventListener("keydown", listener)

      return () => {
        document.removeEventListener("keydown", listener)
      }
    }
  }, [shortCut, sending, startRequest])

  return (
    <Fragment>
      <div ref={props.buttonRef} onClick={() => startRequest()} style={props.style} className={classNames({"btn btn-success": !props.className}, props.buttonSize ? "btn-" + props.buttonSize : undefined, props.className, {disabled: props.disabled || sending})}>
        {sending ? (
          <>
            <i className={classNames("fa fa-spinner fa-spinner", {"fa-fw": !props.showAsLabel})}/>{" "}
            {props.labelSending !== undefined ? (
              props.labelSending ? props.labelSending : "Sending..."
            ) : (props.children)}
          </>
        ) : (
          <>
            <i className={classNames(finished && props.iconFinished ? props.iconFinished : props.icon, {"fa": !props.doNotSetFaClass, "fa-fw": !props.showAsLabel})}/>{" "}
            {finished && props.labelFinished ? 
              <>
                {props.labelFinished}
              </>
              :
              <>
                 {props.label !== undefined ? (
                    props.label ? props.label : "Send"
                  ) : (props.children)}
               </>

            }
          </>
        )}


      </div>
    </Fragment>
  )
}
export default AjaxButton